<template>
  <div>
    <div class="content_header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/main?lang=' + lang }">{{
          cooperation.title
        }}</el-breadcrumb-item>
        <el-breadcrumb-item v-for="(item, index) in brandList" :key="index">{{
          item.categoryName
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div style="border: 1px solid #e5e5e5; margin-top: 20px; margin-left: 20px; margin-right: 10px;">
      <div class="div1" style="margin-top: 10px;">
        <span style="line-height: 30px; margin-top: 10px">{{ $t("section.filterTag") }} : </span>
      </div>
      <div class="div2 content_tag">
        <div class="tag-group div2-tag">
          <el-row class="div2-row-tag">
            <button class="el-row-span" style="min-width: 100px; cursor: pointer;border-radius: 10px; margin-left: 20px; height: 38px;
              border:none; text-align: center;" v-for="item in tagsList"
              :key="item.tagName" :class="{ active: active == item.tagName, default: true }"
              @click="selectedTag(item.tagName, item.id, item.isAll)">
              &nbsp;&nbsp;{{ item.tagName }}&nbsp;&nbsp;
            </button>
          </el-row>
        </div>
      </div>
      <div class="div3" style="margin-top: 10px;margin-bottom: 10px;">
        <span style="line-height: 30px; margin-top: 20px">{{ $t("document.documentType") }} :
        </span>
      </div>
      <div class="div4 content_category" style="padding-bottom: 30px;">
        <div class="tag-group" style="margin-top: 10px;">
          <el-row class="el-row-tag">
            <button class="el-row-span" style="margin-top: 5px;min-width: 100px; cursor: pointer;border-radius: 10px; margin-left: 20px; height: 38px;
            border:none; text-align: center;"
              v-for="items in documentList" :key="items.tagName"
              :class="{ actives: actives == items.tagName, default: true }"
              @click="selected(items.tagName, items.id, items.isAll)">
              &nbsp;&nbsp;{{ items.tagName }}&nbsp;&nbsp;
            </button>
          </el-row>
        </div>
      </div>
    </div>

    <!--节点过滤  -->
    <div class="content_table">
      <table class="table-set">
        <el-tree class="filter-tree document-tree-list" icon-class="el-icon-document-copy" :data="data"
          :empty-text="$t('document.emptyResult')" :props="defaultProps" :default-expand-all="defaultExpandAll"
          :filter-node-method="filterNode" ref="tree">
          <span slot-scope="{ node, data }" style="width: 95%">
            <tr style="width: 100%; line-height: 43px">
              <td style="width: 60%">
                <span class="fixed-label align-middle" @click="handleView(data)" style="line-height: 21px;">
                  <!-- 文字过长显示气泡 -->
                  <span v-if="data.fileName.length > 20">
                    <el-tooltip placement="right">
                      <div slot="content">{{ data.fileName }}</div>
                      <span>{{ data.fileName }}</span>
                    </el-tooltip>
                  </span>
                   <span v-else>{{ data.fileName }}</span>
                </span>
              </td>
              <td style="width: 20%; text-align: right">
                <span v-if="data.isCatalogue === 1">
                  <span class="fixed-width align-middle" style="margin-left: 80px">{{
                    data.updateTime
                  }}</span>
                </span>
              </td>
              <td style="width: 10%; text-align: left">
                <span v-if="data.isCatalogue === 1">
                  <span class="align-middle fixed-width" style="margin-left: 50px">
                    <!-- <p class="el-icon-view" @click="handleView(data)"></p > -->
                    <p class="el-icon-download" style="margin-left: 3px" @click="handleDownloadPDF(data)"></p>
                  </span>
                </span>
                <span v-if="data.isCatalogue === 0">
                  <span class="align-middle fixed-width" style="margin-left: 50px">
                    <!-- <p class="el-icon-view" @click="handleView(data)"></p > -->
                    <p class="el-icon-download" style="margin-left: 3px" @click="handleDownload(data)"></p>
                  </span>
                </span>
              </td>
            </tr>
          </span>
        </el-tree>
      </table>

      <div v-if="total > 10">
        <el-row class="list-pagination" style="margin-bottom:10px;padding-top: 25px;">
          <el-pagination style="margin-right: 2px;" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
            :page-sizes="[10]" :page-size="10" layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </el-row>
      </div>
    </div>
    <!-- <div class="content_end">
      <div></div>
    </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import { messageWarn } from "@/utils/util";
import 'element-ui/lib/theme-chalk/index.css';
import { switchLanguage } from "@/api/sigen/paginationLang";
import { listBase, listTechnical, downloadLocalPdf, downloadLocalZip } from "@/api/sigen/documentCenter";
import streamSaver from 'streamsaver';
export default {
  inject: ["getCateId"],
  data() {
    return {
      language: this.$i18n.locale,
      Info: "Info",
      info: "info",
      login: false,
      isLogin: 0,
      lang: "en",
      filterText: "",
      tagsList: [],
      documentList: [],
      brandList: [],
      cooperation: "",
      loginView: 0,
      fileType: -1,
      fileName: "",
      filePath: "",
      tagId: "-1",
      categoryId: "-1",
      listLoading: true,
      isLastPage: false,
      defaultExpandAll: true,
      total: 0,
      pageNum: 1,
      pageSize: 10,
      data: [],
      defaultProps: {
        children: "children",
        label: "label"
      },
      items: [
        { type: "info", label: "文档文件" },
        { type: "info", label: "视频文件" },
        { type: "info", label: "录音文件" },
        { type: "info", label: "其他" }
      ],
      listTag: [
        { type: "info", label: "标签一" },
        { type: "info", label: "标签二" },
        { type: "info", label: "标签三" },
        { type: "info", label: "标签四" },
        { type: "info", label: "标签五" }
      ],
      actives: "全部",
      active: "全部"
    };
  },
  filterText(val) {
    this.$refs.tree.filter(val);
  },
  mounted() {
    // console.log(">>>>>>>>>>>>>>>>>>>>>>>>  mounted  getCateId :  ", this.getCateId());
  },
  created() {
    let lang = this.getRouteParams();
    this.handleSetLanguage(lang);
    this.checkLogin();
    this.lang = lang;
    this.switchLanguage(this.lang);
    this.listStepPull(this.isLogin, lang, this.getCateId());
    let val = this.getCateId();
    this.categoryId = val;
    this.fileType = -1;
    this.tagId = -1;
    // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> val this.categoryId  : ", val);
    this.listTechnicalPull(
      this.loginView,
      this.fileType,
      lang,
      this.fileName,
      this.tagId,
      val,
      this.pageNum,
      this.pageSize
    );
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo
    })
  },
  methods: {
    switchLanguage(lang) {
      switchLanguage(lang)
    },
    selected(name, type, all) {
      this.actives = name;
      this.chooseFileType(type, all);
    },
    selectedTag(name, tagId, all) {
      this.active = name;
      this.chooseTagId(tagId, all);
    },
    async downloadFile(url) {
      // const url = 'https://support-video-ap.sigenergy.com/marketing/case/20231025142329.mp4'; // 替换为你的文件URL
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText);
        }

        const contentDisposition = response.headers.get('content-disposition');
        const file = url.slice(url.lastIndexOf('/') + 1, 1000);
        const filename = contentDisposition ? contentDisposition.match(/filename="(.+)"/)[1] : file;

        const fileStream = streamSaver.createWriteStream(filename);

        const reader = response.body.getReader();
        const writer = fileStream.getWriter();

        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            writer.close();
            console.log('Download complete');
            break;
          }
          await writer.write(value);
        }
      } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      if (this.listLoading) {
        messageWarn(this, this.$t("load.loading"));
        return;
      }
      this.listTechnicalPull();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      if (this.listLoading) {
        messageWarn(this, this.$t("load.loading"));
        return;
      }
      this.listTechnicalPull();
    },
    listStepPull(isLogin, lang, cateId) {
      if (lang === undefined) {
        return;
      }
      listBase(isLogin, lang, cateId)
        .then((res) => {
          this.tagsList = res.data.result.tagsList;
          this.cooperation = res.data.result.cooperation;
          this.brandList = res.data.result.brandList;
          if (this.tagsList !== null && this.tagsList !== undefined) {
            this.active = this.tagsList[0].tagName;
          }
          this.documentList = res.data.result.documentList;
          if (this.documentList !== null && this.documentList !== undefined) {
            this.actives = this.documentList[0].tagName;
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    chooseFileType(fileType, all) {
      this.fileType = fileType;
      if (all === 1) {
        this.fileType = -1;
      }
      this.listTechnicalPull();
    },
    chooseTagId(tagId, all) {
      this.tagId = tagId;
      if (all === 1) {
        this.tagId = "-1";
      }
      this.listTechnicalPull();
    },
    listTechnicalPull() {
      listTechnical(
        this.loginView,
        this.fileType,
        this.lang,
        this.fileName,
        this.tagId,
        this.categoryId,
        this.pageNum,
        this.pageSize
      )
        .then((res) => {
          this.data = res.data.result.data;
          this.total = res.data.result.total;
          this.isLastPage = res.data.result.isLastPage;
          this.listLoading = false;
        })
        .catch((error) => {
          messageWarn(this, this.$t("load.noMoreData:" + error.$message));
          this.listLoading = false;
        });
    },
    handleNodeClick(data, node, component) {
      // 在这里处理节点点击事件
      console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>   result  : ", data, node, component);
    },
    handleDownload(data) {
      // file downlouad
      console.log(">>>>>>>>>>>>>>>>>>>>>>>>>> handleDownload data result fileName : ", data.fileName);
      console.log(">>>>>>>>>>>>>>>>>>>>>>>>>> handleDownload data result data id : ", data.id);
      var name = '';
      var charToCheck = '.';
      if (data.fileName === undefined || data.fileName === null) {
        name = 'documents.zip';
      } else {
        var filename = data.fileName;
        if (data.fileName.includes(charToCheck)) {
          filename = data.fileName.substring(0, data.fileName.lastIndexOf(charToCheck));
        }

        name = filename + '.zip';
      }

      downloadLocalZip(data.id, name);
      this.$message('Tip: Start downloading');
    },
    async handleDownloadPDF(data) {
      // file downlouad
      console.log(">>>>>>>>>>>>>>>>>>>>>>>>>> handleDownloadPDF fileName : ", data.fileName);
      if (data.fileName.indexOf('.pdf') < 0) {
        this.downloadFile(data.filesUrl);
      } else {
        console.log(">>>>>>>>>>>>>>>>>>>>>>>>>> handleDownloadPDF data id : ", data.id);
        var name = '';
        var charToCheck = '.';
        if (data.fileName === undefined || data.fileName === null) {
          name = 'documents.pdf';
        } else {
          var filename = data.fileName;
          if (data.fileName.includes(charToCheck)) {
            filename = data.fileName.substring(0, data.fileName.lastIndexOf(charToCheck));
          }

          console.log(">>>>>>>>>>>>>>>>>>>>>>>>>> handleDownloadPDF filename : ", filename);
          name = filename + '.pdf';
        }
        console.log("---->filename:" + data.fileName);
        // eslint-disable-next-line no-undef
        downloadLocalPdf(data.id, name);
      }
      this.$message('Tip: Start downloading');
    },
    handleView(data) {
      if (data.isCatalogue === 0) {
        return;
      }
      // file view
      window.open(data.filesUrl, "_blank");
    },
    getRouteParams() {
      // 使用 let phone=this.$route.query.name 来获Get请求参数的值
      let lang = this.$route.query.lang;
      return lang;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleSetLanguage(lang) {
      this.$i18n.locale = lang;
      this.language = lang;
    },
    checkLogin() {
      if (this.userInfo.id !== undefined) {
        this.login = true;
      }
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleTest(data) {
      console.log(">>>>>>>>>>>>>>>>>>>>>>>>>> handleTest data.fileName : ", data.fileName);
    }
  }
}
</script>

<style lang="scss">
.document-tree-list {
 .el-tree-node__content {
  height: 48px;
 }
}
</style>

<style lang="scss" scoped>
.img_sign {
  height: 15px;
  width: 15px;
}

.content_header {
  margin-left: 10px;
  line-height: 30px;
  margin-top: 30px;
}

.content_category {
  margin-left: 20px;
  height: 40px;
  //margin-top: 20px;
  .tag {
    margin-left: 20px;
  }
}

.el-row-tag {
  font-size: 16px;
  color: #808080;
  cursor: pointer;
  margin-left: 10px;
}

.el-row-span {
  margin-top: 5px;
  background-color:#f6f6f8;
}

.content_tag {
  margin-top: 10px;
  // .tag {
  //   margin-left: 20px;
  // }
}

.content_table {
  margin-left: 18px;
  margin-top: 10px;
  font-size: 15px;
  background-color: #f6f6f8;
  margin-bottom: auto;
  margin-right: auto;
  border: 0px;
}

.table-set {
  width: 100%;
  margin-top: 30px;
  border-collapse: collapse;
  border: 0px solid #e5e5e5;
}

/* 调整树形控件节点的上下行距 */
.el-tree .el-tree-node__content {
  margin-top: 5px;
  /* 设置节点之间的上边距 */
  margin-bottom: 5px;
  /* 设置节点之间的下边距 */
  padding-top: 5px;
  /* 设置子节点列表的左内边距 */
  padding-bottom: 5px;
  font-size: 30px;
  margin-left: 20px;
  background: red;
}

/* 调整树形控件节点和其子节点列表之间的距离 */
.el-tree .el-tree-node__children {
  padding-top: 45px;
  /* 设置子节点列表的左内边距 */
  padding-bottom: 45px;
  font-size: 30px;
}

.docum_search {
  width: 30%;
}

.content_end {
  margin-left: 20px;
  width: 90%;
  text-align: center;
}

.fixed-width {
  width: 100px;
  /* 设置固定宽度为200像素 */
  display: inline-block;
  /* 或者使用 block，根据需求选择 */
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 超出部分隐藏 */
  text-overflow: ellipsis;
  /* 超出部分显示省略号，可选 */
  text-align: right;
  margin-right: 20px;
  line-height: 2.5;
  font-size: 14px;
}

.fixed-label {
  width: 550px;
  /* 设置固定宽度为200像素 */
  display: inline-block;
  /* 或者使用 block，根据需求选择 */
  white-space: nowrap;
  /* 防止文本换行 */
  overflow: hidden;
  /* 超出部分隐藏 */
  text-overflow: ellipsis;
  /* 超出部分显示省略号，可选 */
  text-align: left;
  line-height: 2.5;
  font-size: 14px;
}

.list-pagination {
  display: flex;
  justify-content: flex-end;
  margin: 1px 10 0px 0;
  background: #ffffff;
}

.actives {
  font-size: 14px;
  background: #00b5b1;
  border: 1px solid #00b5b1;
  color: #fff;
  border-radius: 10px;
  /* 圆角半径 */
  padding: 5px;
  /* 内边距 */
  margin: 5px;
  /* 外边距 */
}

.active {
  font-size: 14px;
  background: #00b5b1;
  border: 1px solid #00b5b1;
  color: #fff;
  border-radius: 10px;
  /* 圆角半径 */
  padding: 5px;
  /* 内边距 */
  margin: 5px;
  /* 外边距 */
}

.div1,
.div2 {
  margin: 3px;
}

.div1 {
  margin-bottom: 1px;
  margin-left: 10px;
}

.div2 {
  border: 0px solid #e5e5e5;
}

.div2-tag {
  min-height: 40px;
  margin-bottom: 10px;
  padding: 10px;
}

.div2-row-tag {
  font-size: 16px;
  line-height: 1.5;
  color: #808080;
  width: 100%;
  cursor: pointer;
  line-height: 36px;
}

.div3,
.div4 {
  margin: 3px;
}

.div3 {
  margin-bottom: 1px;
  margin-left: 10px;
  margin-top: 10px;
}

.div4 {
  border: 0px solid #e5e5e5;
  height: 40px;
  font-size: 5px;
}

// // .el-tree {
// //   background: #02163C;
// // }

// .tree {
//     .el-tree-node {
//       white-space: normal;
//       .el-tree-node__content {
//         height: 100px;
//         align-items: start;
//       }
//     }
//   }
</style>



// WEBPACK FOOTER //
// src/components/Technical/index.vue